import { Injectable, Inject, LOCALE_ID } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ProofOfDebtRemarkMessage } from '../../interfaces/proofOfDebtRemarkMessage';

@Injectable()
export class CreditorRemarkService {
  constructor(
    private http: HttpClient,
    @Inject('API_URL') protected apiUrl: string,
    @Inject(LOCALE_ID) protected localeId: string) {
  }

  public sendResponse(gkRemarkId: string, caseId: string, message: string, files: File[], approved: boolean, creditorId: string): Observable<ProofOfDebtRemarkMessage[]> {
    let formdata = new FormData();
    formdata.append("message", message);
    for(let ix = 0; ix < files.length; ix++)
      formdata.append("files", files[ix]);
    formdata.append("approved", approved.toString());

    return this.http.post<ProofOfDebtRemarkMessage[]>(`${this.apiUrl}/Creditor/RemarkMessage/${gkRemarkId}/${caseId}/${creditorId}`, formdata);
  }
}
